<div *ngFor="let section of sections$ | async; trackBy: sectionTrackBy">
  <div
    class="typography typography-h3 green-basic mt-16 py-8 kb-section"
    #section
    [id]="'kb-section-' + section.symbol"
  >
    {{ section.symbol }}
  </div>

  <app-helix-book-list-item
    class="list"
    *ngFor="let item of section.items; trackBy: itemTrackBy"
    [item]="item"
  ></app-helix-book-list-item>
</div>

<div
  *ngIf="!(sections$ | async)?.length"
  class="empty min-h-208 max-h-768"
  style="height: 60vh"
>
  По вашему запросу ничего не найдено
</div>
